import React, { Component } from "react";
import {
  Grid,
  Typography,
  Fab,
  TextField,
  IconButton,
  Button,
  Hidden,
  Icon,
  FormControl,
  Select,
  MenuItem, FormControlLabel, Switch,
} from "@material-ui/core";
import { Add } from "@material-ui/icons";
import { connect } from "react-redux";
import ReactAutocomplete from "react-autocomplete";
import UPDATE_CHEF from "../../graphql/mutations/chef/update_chef";
import style from "./style";
import { NotificationManager } from "react-notifications";
import { GET_CHEF_DETAILS } from "../../graphql/queries/chef";
import { compose, graphql } from "react-apollo";
import { Dish } from "../../components/Dishes/Dish";
import { webFont, primaryColor, fontColor } from "../../config/theme";
import FileUpload from "../../components/FileUpload/upload-portfolio-image";
import VideoUpload from '../../components/FileUpload/video-upload';
import ImageView from "../../components/Image";
import {client} from "../../config/apollo";
import Breadcrumbs from "../../components/Breadcrumbs";

class PFolio extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isModalOpen: false,
      selectedImage: null,
      cuisines:
        props.cuisines &&
        props.cuisines.length &&
        props.cuisines.map(item => {
          return { name: item, selected: false };
        }),
      cuisine: "",
      about: props.chef ? props.chef.story : " ",
      selected:
        props.chef && props.chef.cuisines && props.chef.cuisines.length
          ? props.chef.cuisines.map(item => {
              return { name: item, selected: true };
            })
          : [],
      chef: props.chef,
      chefType: "PROFESSIONAL_CHEF",
      media: props.chef ? props.chef.media : [],
      chefProfilePic: "",
      minPrice: props.chef ? props.chef.minEngagementPrice : null,
      maxDiners: props.chef ? props.chef.maxDiners : null,
      hourlyPrice: props.chef ? props.chef.hourlyPrice: null,
      s3: props.chef ? props.chef.s3 : null,
      vimeoId: props.chef ? props.chef.vimeoId : null,
      list: props.cuisines ? props.cuisines : [],
      selectedToDelete: [],
      cuisineToBeDeleted: ''
    };

    this.mediaBoxRef = React.createRef();
    this.addMedia = this.addMedia.bind(this);
  }

  handleCuisineChange = value => {
    this.setState({ cuisine: value });
  };

  async addMedia(mediaData) {
    let { media = [] } = this.state;
    if (!media) {
      media = [];
    }

    if (mediaData) {
      media.push(mediaData);

      const payload = {
        chef: {
          userId: this.props.userId,
          media: media.map(item => {
            return {
              type: item.type ? item.type: 'PHOTO',
              url: item.url,
              size: item.size ? item.size : 'MEDIUM',
              appType: item.appType ? item.appType : 'MOBILE',
            };
          }),
        }
      };

      client
        .mutate({
        mutation: UPDATE_CHEF,
        variables: payload
      });

      this.setState({
        chefProfilePic: mediaData.url,
        media, loading: false,
      });
    } else {
      this.setState({ media });
    }
  };

  removeMedia = file => {
    this.setState({
      chefProfilePic: "",
      media: []
    });

    const payload = {
      chef: {
        userId: this.props.userId,
        media: []
      }
    };

    client
      .mutate({
        mutation: UPDATE_CHEF,
        variables: payload
      });
  };

  removeVimeo = () => {
    const payload = {
      chef: {
        userId: this.props.userId,
        s3: 'setNull',
        vimeoId: 'setNull',
      }
    };

    this.props.onSubmit(payload);

    this.setState({
      s3: null,
      vimeoId: null,
    });

    if (!!this.props.details) {
      this.props.details.refetch();
    }
  };

  componentDidMount() {
    window.onload = function() {
      window.scrollTo(0, 0);
    };

    if (this.props.location && this.props.location.state) {
      if (this.props.location.state) {
        const {
          selected,
          about,
          chefType,
          chef
        } = this.props.location.state;

        let aboutMe = about || (chef && chef.story);

        let myChefType = chefType || (chef && chef.chefType);

        this.setState({
          selected,
          about: aboutMe,
          chefType: myChefType,
          maxDiners: chef ? chef.maxDiners : null,
          minPrice: chef ? chef.minEngagementPrice : null,
          hourlyPrice: chef ? chef.hourlyPrice : null,
          chefProfilePic:
            (!!chef &&chef.media &&
              chef.media.length &&
              chef.media[chef.media.length - 1].url) ||
            ""
        });
      }
    } else {
      if (this.props.chef) {
        const selected = this.props.chef
          ? (this.props.chef.cuisines ? this.props.chef.cuisines.map(item => {
              return { name: item, selected: true };
            }) : [])
          : [];
        this.setState({
          selected,
          about: this.props.chef ? this.props.chef.story : " "
        });
      }
    }
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    if (!!nextProps.chef && !!nextProps.chef.cuisines && !prevState.selected) {
      const selected = nextProps.chef.cuisines.map(item => ({ name: item, selected: true }));
      return { selected };
    } else {
      return null;
    }
    /*if (nextProps) {
      if (!!nextProps.details) {
        const updatedState = {};
        if (!!nextProps.details.chef) {
          let myMedia = nextProps.details.chef.media || [];
          if (myMedia.length > 0) {
            myMedia = myMedia.map(m => {
              return {
                type: m.type,
                url: m.url,
                size: m.size,
                appType: "WEB"
              };
            });

            updatedState.media = myMedia;
          }
        }

        /!*if (!!nextProps.details.chef) {
          if (!!nextProps.details.chef.s3) {
            console.log('NEXT PROPS S3: ', nextProps.details.chef.s3);
            updatedState.s3 = nextProps.details.chef.s3;
            updatedState.vimeoId = nextProps.details.chef.vimeoId;
          }
        }*!/

        return updatedState;
      }
    }
    return null;*/
  }

  onSavePortfolio = () => {
    let { media } = this.state;

    media = !media ? [] : media.map(item => {
      return {
        type: item.type ? item.type: 'PHOTO',
        url: item.url,
        size: item.size ? item.size : 'MEDIUM',
        appType: item.appType ? item.appType : 'MOBILE',
      };
    });

    let cuisines =
      this.state.selected &&
      this.state.selected.length &&
      this.state.selected
        .filter(c => {
          return c.selected;
        })
        .map(c => {
          return c.name;
        });

    let chefFromProps = this.props.details.chef;


    if (cuisines == 0 || cuisines.length <= 0) {
      NotificationManager.error('Cuisines cannot be empty', 'Portfolio');
      return;
    }

    if (!this.state.minPrice) {
      NotificationManager.error('Min engagement price cannot be less than $50', 'Portfolio');
      return;
    }

    if (!this.state.hourlyPrice) {
      NotificationManager.error('Hourly price cannot be less than $10', 'Portfolio');
      return;
    }

    const chefPayload = {
      userId: this.props.userId,
      cuisines: cuisines ? cuisines : chefFromProps.cuisines,
      story: this.state.about,
      chefType: this.state.chefType,
      completedSetupStep: 11,
      minEngagementPrice: this.state.minPrice && this.state.minPrice !== '' ? parseFloat(this.state.minPrice) : (this.props.details.chef ? (this.props.details.chef.minEngagementPrice ? parseFloat(this.props.details.chef.minEngagementPrice) : null) : null),
      hourlyPrice: this.state.hourlyPrice && this.state.hourlyPrice !== '' ? parseFloat(this.state.hourlyPrice) : (this.props.details.chef ? (this.props.details.chef.hourlyPrice ? parseFloat(this.props.details.chef.hourlyPrice) : null) : null),
      maxDiners: this.state.maxDiners && this.state.maxDiners !== '' ? parseInt(this.state.maxDiners) : 0,
    };

    if (!chefPayload.minEngagementPrice) {
      if (chefFromProps) {
        if (chefFromProps.minPrice) {
          chefPayload.minEngagementPrice = parseFloat(chefFromProps.minPrice);
        }
        else {
          NotificationManager.error('Min engagement price cannot be less than $50', 'Portfolio');
          return;
        }
      } else {
        NotificationManager.error('Min engagement price cannot be less than $50', 'Portfolio');
        return;
      }
    }

    if (chefPayload.minEngagementPrice < 50) {
      NotificationManager.error('Min engagement price cannot be less than $50', 'Portfolio');
      return;
    }

    if (!chefPayload.hourlyPrice) {
      if (chefFromProps) {
        if (chefFromProps.hourlyPrice) {
          chefPayload.hourlyPrice = parseFloat(chefFromProps.hourlyPrice);
        }
        else {
          NotificationManager.error('Hourly price cannot be less than $10', 'Portfolio');
          return;
        }
      } else {
        NotificationManager.error('Hourly price cannot be less than $10', 'Portfolio');
        return;
      }
    }

    if (chefPayload.hourlyPrice < 10) {
      NotificationManager.error('Hourly price cannot be less than $10', 'Portfolio');
      return;
    }

    /*if (chefPayload.minEngagementPrice > 10000) {
      NotificationManager.error('Min engagement price cannot be more than $10,000', 'Portfolio');
      return;
    }*/

    if ((!!chefPayload.cuisines && chefPayload.cuisines.length < 1) || !chefPayload.cuisines) {
      if (chefFromProps) {
        if (chefFromProps.selected) {
          cuisines = chefFromProps.selected &&
            chefFromProps.selected.length &&
            chefFromProps.selected
              .filter(c => {
                return c.selected;
              })
              .map(c => {
                return c.name;
              });

          chefPayload.cuisines = cuisines;
        }
        else {
          NotificationManager.error('Cuisines cannot be empty. At least 1 cuisine is needed.', 'Portfolio');
          return;
        }
      } else {
        NotificationManager.error('Cuisines cannot be empty. At least 1 cuisine is needed.', 'Portfolio');
        return;
      }
    }

    const payload = {
      chef: media && media.length > 0 ? { ...chefPayload, media } : chefPayload,
      user: {}
    };

    if (!!this.state.profilePic && this.state.profilePic.length > 0) {
      payload.user.profilePic = this.state.profilePic;
    }

    this.props.onSubmit(payload);
  };

  handleChange = event => {
    this.setState({ chefType: event.target.value });
  };

  removeCuisine = () => {
    const { selected = [], cuisineToBeDeleted } = this.state;
    const list = this.props.cuisines;

    if(cuisineToBeDeleted.trim().length<=0)
      return;

    if (selected && selected.length && selected.find(c => c.name === cuisineToBeDeleted)) {
      const index = selected.findIndex(c => c.name === cuisineToBeDeleted);
      selected.splice(index, 1);
    }

    this.setState({ selected, cuisine: "", selectedToDelete: [], cuisineToBeDeleted: '' });
  };

  addCuisine = () => {
    const { selected = [], cuisine } = this.state;
    const list = this.props.cuisines;

    if(cuisine.trim().length<=0)
        return;

    if (!list.find(c => c.toLowerCase() === cuisine.toLowerCase())) {
      NotificationManager.error("For any new cuisines to be added in the list, please make a feature request in Feedback under Account", "Cuisines");
      return;
    }

    if (selected && selected.length && selected.find(c => c.name === cuisine)) {
      NotificationManager.error(cuisine + " is already selected", "Portfolio");
      return;
    }
    selected.push({
      name: cuisine,
      selected: true
    });
    this.setState({ selected, cuisine: "" });
  };

  selectCuisine = (index, value) => {
    const { selected } = this.state;
    let { selectedToDelete } = this.state;

    selected[index].selected = value;

    if (!value) {
      selectedToDelete.push(index);
    } else {
      const cIndex = selectedToDelete.findIndex((item => item === index))
      if (cIndex > -1) {
        selectedToDelete.splice(cIndex, 1);
      }
    }
    this.setState({ selected, selectedToDelete }, () => {
      this.removeCuisine();
    });

    if (selectedToDelete.length <= 0) {
      this.setState({ cuisineToBeDeleted: '' })
    }
  };

  showVideoMessages = (msg, isErr) => {
    if (isErr) {
      NotificationManager.error(msg, 'Upload video');
    } else {
      NotificationManager.info(msg, 'Upload video');
    }
  };

  render() {
    const { about, s3, vimeoId } = this.state;
    const chefTypes = [
      { name: "Professional Chef", value: "PROFESSIONAL_CHEF" },
      { name: "Professional Cook", value: "PROFESSIONAL_COOK" },
      { name: "Home Cook", value: "HOME_COOK" },
      { name: "Culinary Student", value: "CULINARY_STUDENT" }
    ];

    let chefMedia = [];

    if (!!this.state.media && this.state.media.length > 0) {
      this.state.media.forEach(m => {
        if (m) {
          if (m.size && m.type) {
            if (m.type === 'PHOTO' && m.size !== 'SMALL_SQUARE_THUMBNAIL') {
              chefMedia.push(m);
            }
          }
        }
      });
    } else if (this.state.chefProfilePic !== "") {
      chefMedia.push({
        url: this.state.chefProfilePic,
        type: 'PHOTO',
        size: 'MEDIUM'
      });
    }

    if (chefMedia.length > 1) {
      chefMedia = chefMedia.slice(0, 1);
    }

    let aboutCount  = about ? about.length+'/500' : 0 +'/500';
    const clientWidth = this.mediaBoxRef ? this.mediaBoxRef.current ? this.mediaBoxRef.current.clientWidth : 510 : 510;

    return (
      <div className="chef-right-col profile-setup-column">
        <Grid container>
          <Grid item xs={12}>
          <div className="schedule-head-col">
            {this.props.screen && <div style={{marginLeft: -10, marginTop: 30, marginBottom: 15}}>
              <Breadcrumbs childRoutes={[
                {
                  display: 'Edit Portfolio',
                  link: 'home/edit-portfolio'
                }
              ]} />
            </div>}
            <div className="header-step-col">
              <p className="located-text" style={style.headerText}>
                Portfolio setup
              </p>
            </div>
          </div>

            {this.props.match.path === '/edit-portfolio' && <Grid container>
              <Grid item xs={12} xl={12} lg={12} className="status-header-status">
                <Grid container style={{display: "flex"}} alignContent='center' alignItems='center' justify='flex-start'
                      className="chef-status">
                  <p
                      style={{
                        fontFamily: webFont,
                        fontWeight: 500,
                        fontSize: 24,
                        marginRight: 60,
                      }}
                  >
                    Status
                  </p>
                  <FormControlLabel
                      style={{fontFamily: webFont, fontSize: '18px'}}
                      checked={this.props.chef ? this.props.chef.active : true}
                      control={
                        <Switch
                            data-test-id={"chefact-id"}
                            value="checked"
                            onChange={() => {
                              this.props.changeActiveStatus();
                            }
                            }
                        />
                      }
                      label={this.props.chef && this.props.chef.active ? 'Active' : 'Inactive'}
                      labelPlacement="start"
                  />
                </Grid>
              </Grid>
            </Grid>}

            <Typography
              variant="h6"
              align="left"
              style={{ ...styles.setFont, ...{ fontSize: 24, fontWeight: 500, margin: '32px 0 16px' } }}
            >
              My photos / videos
            </Typography>
            <Grid container style={{ flexWrap: 'no-wrap' }} ref={this.mediaBoxRef}>
              {!!chefMedia &&
                chefMedia.map((image, i) => (
                  <ImageView
                    clientWidth={clientWidth}
                    data-test-id={"pfimg-id"}
                    key={i + "image"}
                    url={image.url}
                    page="portfolio"
                    onDelete={() => {
                      this.removeMedia(image);
                    }}
                  />
                ))}
              {!!chefMedia && chefMedia.length <= 0 && <FileUpload
                clientWidth={clientWidth}
                onUploadStart={() => this.setState({ loading: true })}
                onSuccess={res => this.addMedia(res.data)}
                onError={err => console.log(err)}
                fileType="IMAGE"
              />}
              {s3 === null && vimeoId === null ? (
                <VideoUpload
                  clientWidth={clientWidth}
                  onUploadStart={() => this.setState({ loading: true })}
                  onSuccess={res => {
                    if (!!this.props.details) {
                      this.props.details.refetch();
                    }
                    this.setState({ loading: false, s3: { processing: true } });
                    NotificationManager.info('The video is processing. Please check back later.', 'Video Upload');
                  }}
                  onError={err => console.log(err)}
                  fileType="VIDEO"
                  showVideoMessages={this.showVideoMessages}
                  s3={s3}
                />
              ) : !s3.failed && s3.processed ? (
                <ImageView
                  clientWidth={clientWidth}
                  page={"portfolio"}
                  data-test-id={"vimvid-id"}
                  key={"vimeoVideo"}
                  videoId={vimeoId}
                  onDelete={() => {
                    this.removeVimeo();
                  }}
                />
              ) : (
                <div>
                  <VideoUpload
                    onUploadStart={() => this.setState({ loading: true })}
                    onSuccess={res => {
                      if (!!this.props.details) {
                        this.props.details.refetch();
                      }
                      this.setState({ loading: false, s3: {processing: true} });
                      NotificationManager.info('The video is processing. Please check back later.', 'Video Upload');
                    }}
                    onError={err => console.log(err)}
                    fileType="VIDEO"
                    showVideoMessages={this.showVideoMessages}
                    s3={s3}
                  />
                </div>
              ) }
            </Grid>
          </Grid>

          <Grid item xs={12} style={{ marginTop: 47 }}>
            <ReactAutocomplete
              items={this.props.cuisines}
              shouldItemRender={(item, value) =>
                item.toLowerCase().indexOf(value.toLowerCase()) > -1 &&
                value.length > 0
              }
              getItemValue={item => item}
              renderItem={(item, highlighted) => (
                <div
                  key={new Date().getMilliseconds() + item}
                  style={style.suggenstionBox}
                >
                  <p style={style.suggestionText}> {item}</p>
                </div>
              )}
              value={this.state.cuisine}
              menuStyle={{
                zIndex: 100,
                maxHeight: 100,
                overflow: "auto"
              }}
              wrapperProps={{
                style: {
                  width: "100%",
                  marginBottom: 0
                }
              }}
              onChange={e => this.handleCuisineChange(e.target.value)}
              onSelect={value => this.setState({ cuisine: value })}
              renderInput={props => {
                return (
                  <div className="group portfolio-group">
                      <Typography
                        variant="h5"
                        align="left"
                        style={{
                          ...styles.setFont,
                          ...styles.topHead,
                          ...{ fontSize: 24, fontWeight: 500 }
                        }}
                      >
                        Cuisines *
                      </Typography>
                      <div style={{ display: "flex", justifyContent: "space-between" }}>
                          <div style={{flex:'1'}}>
                          <input
                            data-test-id={"enterpfcuis-id"}
                            className="mat-input"
                            style={{ paddingTop: 10, paddingBottom: 10 }}
                            placeholder="Enter cuisine"
                            type="text"
                            {...props}
                          />
                              <span className="highlight" />
                          </div>
                        {/*{this.state.selectedToDelete.length > 0 ?
                          <IconButton
                          data-test-id={"removecuis-id"}
                          color="default"
                          aria-label="Remove"
                          size="small"
                          style={{ position: 'absolute', top: 43, right: 0, padding: 0 }}
                          disabled={this.state.selectedToDelete.length <= 0}
                          onClick={() => this.removeCuisine()}
                        >
                          <Icon
                            style={{ fontSize: 32, }}
                            color={
                              this.state.selectedToDelete.length > 0 ? "primary" : "action"
                            }
                          >
                            remove_circle
                          </Icon>
                        </IconButton> : */}<IconButton
                            data-test-id={"addcuis-id"}
                            color="default"
                            aria-label="Add"
                            size="small"
                            style={{ position: 'absolute', top: 43, right: 0, padding: 0 }}
                            disabled={this.state.cuisine.length <= 0}
                            onClick={() => this.addCuisine()}
                          >
                            <Icon
                              style={{ fontSize: 32, }}
                              color={
                                this.state.cuisine.length > 0 ? "primary" : "action"
                              }
                            >
                              add_circle
                            </Icon>
                          </IconButton> {/*}*/}
                    </div>


                  </div>
                );
              }}/>
          </Grid>
          <Grid item xs={12} style={{marginTop: 45}}>
            <Grid container>
              {this.state.selected &&
                !!this.state.selected.length &&
                this.state.selected.map((item, index) => (
                  <Button
                    // fullWidth
                    key={index + item.name}
                    variant={item.selected ? "contained" : "outlined"}
                    color="primary"
                    style={
                      item.selected
                        ? style.cuisineButtonSelected
                        : style.cuisineButton
                    }
                    disableRipple={true}
                    onClick={() => {
                      this.selectCuisine(index, !item.selected);
                      this.setState({ cuisineToBeDeleted: item.name })
                    }}
                  >
                    {item.name}
                  </Button>
                ))}
            </Grid>
          </Grid>
          <Grid item xs={12} style={{ marginTop: 42 }}>
            <Typography
              variant="h5"
              align="left"
              style={{
                ...styles.setFont,
                ...styles.topHead,
                fontWeight: 500,
                fontSize: 24
              }}
            >
              About me
            </Typography>
            <Grid item xs={12}>
            {/*<Typography
                variant="h1"
                align="right"
                style={{
                  ...styles.setFont,
                  ...styles.topHead,
                  fontWeight: 500,
                  fontSize: 12,
                  marginBottom:5
                }}
            >
              {aboutCount}
            </Typography>*/}
            </Grid>
            <Grid item xs={12}>
              <TextField
                inputProps={{ 'data-test-id': 'pfabtme' }}
                multiline
                variant="outlined"
                rows="15"
                fullWidth
                value={this.state.about}
                onChange={evt => {
                  this.setState({ about: evt.target.value });
                }}
                style={{ ...styles.setFont }}
              />
            </Grid>
          </Grid>
          <Grid item xs={12} style={{ marginTop: 42 }}>
            <Typography
              variant="h5"
              align="left"
              style={{
                ...styles.setFont,
                ...styles.topHead,
                fontWeight: 500,
                fontSize: 24
              }}
            >
              Minimum engagement price *
            </Typography>
            <Grid item xs={12}>
              <TextField
              inputProps={{ 'data-test-id': 'pfprice' }}


                fullWidth
                value={this.state.minPrice}
                onChange={evt => {
                  this.setState({ minPrice: evt.target.value });
                }}
                style={{ ...styles.setFont }}
              />
            </Grid>
          </Grid>
          <Grid item xs={12} style={{ marginTop: 42 }}>
            <Typography
              variant="h5"
              align="left"
              style={{
                ...styles.setFont,
                ...styles.topHead,
                fontWeight: 500,
                fontSize: 24
              }}
            >
              Maximum diners per engagement
            </Typography>
            <Grid item xs={12}>
              <TextField
              inputProps={{ 'data-test-id': 'engmtsize' }}


                fullWidth
                value={this.state.maxDiners === 0 ? "" : this.state.maxDiners}
                onChange={evt => {
                  this.setState({ maxDiners: evt.target.value });
                }}
                style={{ ...styles.setFont }}
              />
            </Grid>
          </Grid>

          <Grid item xs={12} style={{ marginTop: 42 }}>
            <Typography
              variant="h5"
              align="left"
              style={{
                ...styles.setFont,
                ...styles.topHead,
                fontWeight: 500,
                fontSize: 24
              }}
            >
              Hourly price for engagement *
            </Typography>
            <Grid item xs={12}>
              <TextField
                inputProps={{ 'data-test-id': 'hourlyprice' }}
                fullWidth
                value={this.state.hourlyPrice === 0 ? "" : this.state.hourlyPrice}
                onChange={evt => {
                  this.setState({ hourlyPrice: evt.target.value });
                }}
                style={{ ...styles.setFont }}
              />
            </Grid>
          </Grid>

          <Grid item xs={12} style={{ marginTop: 42 }}>
            <Typography
              variant="h5"
              align="left"
              style={{
                ...styles.setFont,
                ...styles.topHead,
                fontWeight: 500,
                fontSize: 24
              }}
            >
              Select chef type
            </Typography>
            <Grid
            data-test-id={"cheftypepf"}
            item md={12}>
              <FormControl fullWidth>
                <Select
                  inputProps={{MenuProps: {disableScrollLock: true}}}
                  value={this.state.chefType} onChange={this.handleChange}>
                  {chefTypes.map((ct, i) => (
                    <MenuItem


                    value={ct.value} key={ct.value + i}>
                      <p style={styles.setFont}> {ct.name}</p>
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
          </Grid>

          <Grid item xs={12} style={{ marginTop: 42 }}>
            <Grid container direction="row">
              <Grid
                item
                xs={12}
                md={12}
                lg={12}
                style={{
                  display: "flex",
                  alignItems: "center",
                  marginBottom: 10
                }}
              >
                <Typography
                  variant="h5"
                  align="left"
                  style={{
                    ...styles.setFont,
                    ...styles.topHead,
                    fontWeight: 500,
                    fontSize: 24,
                      marginRight:20,
                  }}
                >
                  Dishes
                </Typography>
                <Fab
                  data-test-id={"adddishpf"}
                  color="primary"
                  aria-label="Add"
                  size="small"
                  className="dishes-icon"
                  onClick={() => {

                    this.props.history.push("/home/add-dish?destination=chef-steps", {
                      previousRoute: "/home/become-chef?step=8",
                      selected: this.state.selected,
                      about: this.state.about,
                      chefType: this.state.chefType,
                      media: this.state.media
                    })
                  }}>
                  <Add style={styles.btnIcon} />
                </Fab>
              </Grid>
            </Grid>
            <Grid className="dish-container" container alignItems={'center'}>
              <div className="dish-conatiner-row">
              {this.props.chef &&
                this.props.chef.dishesList &&
                this.props.chef.dishesList.dishes.map((dish, i) => {
                  return (
                    <Dish key={i + "dish"} dish={dish} history={this.props.history} />
                  );
                })}
              </div>
            </Grid>

            <Grid
              container
              alignItems="center"
              justify="center"
              direction="row"
              style={{ marginTop: 42 }}
            >
              <Hidden xsUp>
                <Grid item xs={2} />
                <Grid item xs={8}>
                  <Fab
                  data-test-id={"savepf"}

                    variant={"extended"}
                    disabled={this.state.loading}
                    type="submit"
                    onClick={() => this.onSavePortfolio()}
                    style={
                      this.state.loading
                        ? style.submitButtonDisabled
                        : style.submitButton
                    }
                  >
                    Save portfolio
                  </Fab>
                </Grid>
              </Hidden>
              <Hidden xsDown>
                <Grid
                  item
                  md={12}
                  sm={12}
                  style={
                    !this.props.updatePortfolio
                      ? {
                          textAlign: "right"
                        }
                      : { textAlign: "left", marginLeft: 100 }
                  }
                >
                  <Fab
                  data-test-id={"updpf"}

                    variant={"extended"}
                    disabled={this.state.loading}
                    type="submit"
                    onClick={() => this.onSavePortfolio()}
                    style={
                      this.state.loading
                        ? style.submitButtonDisabled
                        : style.submitButton
                    }
                  >
                    Save portfolio
                  </Fab>
                </Grid>
              </Hidden>
              <Hidden smUp>
                <Grid item md={12} sm={12} style={{ textAlign: "right" }}>
                  <Fab
                  data-test-id={"savepf"}

                    variant={"extended"}
                    disabled={this.state.loading}
                    type="submit"
                    onClick={() => this.onSavePortfolio()}
                    style={
                      this.state.loading
                        ? style.submitButtonDisabled
                        : style.submitButton
                    }
                  >
                    Save portfolio
                  </Fab>
                </Grid>
              </Hidden>
            </Grid>
          </Grid>
        </Grid>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    userId: state.auth.userId
  };
};

const EFolio =  compose(
  graphql(GET_CHEF_DETAILS, {
    name: "details",
    options: props => ({
      variables: {
        id: props.userId
      }
    })
  })
)(PFolio);

const Portfolio = connect(mapStateToProps)(EFolio);

export default Portfolio;

const styles = {
  setFont: {
    fontFamily: webFont
  },
  topHead: {
    fontWeight: 800
  },
  addMediaBox: {
    maxWidth: 155,
    height: 155,
    borderWidth: 1,
    borderColor: primaryColor,
    borderStyle: "solid",
    marginRight: 5
  },
  btnPlus: {
    marginTop: 55
  },
  btnPlusDishes: {
    marginLeft: 150
  },
  btnIcon: {
    color: fontColor,
  }
};
